import { useTranslation } from "react-i18next";
import { BirthdaySelect, TownSelect } from "@shared";
import { useStore } from "@stores";
import { Form, Input } from "antd";
import { FormInstance } from "antd/es/form";
import { observer } from "mobx-react";
import { SharedForm } from "../SharedForm";
import { validator } from "./ProfileForm.validator";

interface Props {
  form: FormInstance<any>;
  onCancel: () => void;
  onSubmit: (values: any) => Promise<void>;
}

export const ProfileForm: React.FC<Props> = observer(
  ({ form, onSubmit, onCancel }) => {
    const { t } = useTranslation();
    const { userStore } = useStore();
    const { loading } = userStore;

    return (
      <SharedForm
        form={form}
        loading={loading}
        onFinish={onSubmit}
        onReset={onCancel}
        showReset={false}
      >
        <Form.Item hidden name="id">
          <Input />
        </Form.Item>
        <Form.Item
          name="emailAddress"
          label={t("EmailLabel")}
          rules={[validator]}
        >
          <Input disabled readOnly placeholder={t("EnterEmail")} />
        </Form.Item>

        <Form.Item
          required
          name="phoneNumber"
          label={t("TelephoneLabel")}
          rules={[validator]}
        >
          <Input placeholder={t("EnterTelephone")} />
        </Form.Item>

        <Form.Item
          name="name"
          label={t("NameLabel")}
          required
          rules={[validator]}
        >
          <Input placeholder={t("NamePlaceholder")} />
        </Form.Item>

        <Form.Item
          name="surname"
          label={t("SurnameLabel")}
          required
          rules={[validator]}
        >
          <Input placeholder={t("SurnamePlaceholder")} />
        </Form.Item>

        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) => prev.birthday !== cur.birthday}
        >
          {() => (
            <Form.Item name="birthday" label={t("Birthday")}>
              <BirthdaySelect
                disabled={!!form.getFieldValue("birthday")}
              />
            </Form.Item>
          )}
        </Form.Item>

        <Form.Item name="townId" label={t("Town")}>
          <TownSelect />
        </Form.Item>
      </SharedForm>
    );
  },
);
